module.exports = __webpack_public_path__ + "img/ansible.638fa70b.png";